import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IOneSurvayPayload {
    surveyId: string
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const oneSurvay = createSlice({
    name: 'survey/one-survey',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IOneSurvayPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const oneSurvayActions = oneSurvay.actions
export default oneSurvay.reducer
